import React, { FC, ReactNode, ReactNodeArray } from 'react';
import { Col, Container, Row } from 'styled-bootstrap-grid';
import { container } from '../../const/container';
import { Text } from '../text';
import FooterStyled, { FooterBlock as Block, FooterCopyrightStyled } from './footer.styled';

const Footer: FC<{
  copyright?: string;
  footerText?: string;
  $bgColor?: string;
  logo?: string;
  children?: ReactNode | ReactNodeArray;
}> = ({ children, footerText, copyright = 'Powered by convergehealth safety', $bgColor = '#1E2846' }) => (
  <FooterStyled {...{ $bgColor }}>
    <Container {...container}>
      <Row alignItems="center">
        <Col md={6}>
          <Block>
            <Block>
              {children}
              {footerText && <Text $color="white"> | {footerText}</Text>}
            </Block>
          </Block>
        </Col>
        <Col md={6}>
          <FooterCopyrightStyled>
            {new Date().getFullYear()} © {copyright}
          </FooterCopyrightStyled>
        </Col>
      </Row>
    </Container>
  </FooterStyled>
);

export default Footer;
